var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortTableDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50994 19.207C6.31994 19.207 6.12994 19.137 5.97994 18.987L0.969941 13.977C0.679941 13.687 0.679941 13.207 0.969941 12.917C1.25994 12.627 1.73994 12.627 2.02994 12.917L7.03994 17.927C7.32994 18.217 7.32994 18.697 7.03994 18.987C6.88994 19.127 6.69994 19.207 6.50994 19.207Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51001 19.207C6.10001 19.207 5.76001 18.867 5.76001 18.457V1.45703C5.76001 1.04703 6.10001 0.707031 6.51001 0.707031C6.92001 0.707031 7.26001 1.04703 7.26001 1.45703V18.457C7.26001 18.867 6.92001 19.207 6.51001 19.207Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTableDesc);
export default __webpack_public_path__ + "static/media/sort-table-desc.267b3c23f18b3a5e073b6ae6201e72a7.svg";
export { ForwardRef as ReactComponent };